<template>
    <div class="csv-data">
        <div class="overflow-auto">
            <b-pagination v-if="rows > 50"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="dataTable"
            ></b-pagination>

            <b-table striped hover 
                id="dataTable"
                :items="inputData"
                :per-page="perPage"
                :current-page="currentPage"
                :fields="fields"
            ></b-table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DataTable',
    props: {
        inputData: Array,
        fields: Object
    },
    data() {
        return {
            perPage: 50,
            currentPage: 1,
        }
    },
    filters: {
        capitalize: function(str) {
            return str.toUpperCase();
        }
    },
    computed: {
      rows() {
        return this.inputData.length
      }
    }
}
</script>

<style>
    table {
        width: inherit;
        font-size: 10px;
    }

    .csv-data {
        margin-top: 15px;
        max-width: inherit;
    }
</style>
